export const DEFAULT_SETTINGS = {
  hourlyRate: 45,
  weeksPerYear: 45,
  defaultSavingsPct: 70
};

export const INITIAL_DATA = [];

export const INITIAL_TEMPLATES = [];